import { render } from "./BtnCross.vue?vue&type=template&id=2b7546f4&scoped=true"
import script from "./BtnCross.vue?vue&type=script&lang=js"
export * from "./BtnCross.vue?vue&type=script&lang=js"

import "./BtnCross.vue?vue&type=style&index=0&id=2b7546f4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7546f4"]])

export default __exports__